export default "__VITE_ASSET__BbF2TJP7__"